import multipleSelect from 'multiple-select';
export default function multipleSelectNewsletter() {
  $('.newsletter-areas').multipleSelect({
    formatSelectAll: function () {
      return '[Selecionar todos]';
    },
    formatAllSelected: function () {
      return 'Todos';
    },
    formatCountSelected: function (count, total) {
      return count + ' de ' + total + ' selecionados';
    }
  });
}